import {useEffect} from 'react';

import {DialogContentText, DialogContent, DialogActions} from '@mui/material';
import {useLocation, useNavigate} from 'react-router-dom';

import {APP_ROUTES} from '../../const';
import useWorkspaces from '../../hooks/providers/useWorkspaces';
import Button from '../form/buttons/Button/Button';
import BaseModal from '../modal/BaseModal';

const DeleteWorkspaceOrReportModal = () => {
  const {
    deleteWorkspace,
    deleteReport,
    getReportWorkspace,
    setDeleteWorkspaceOrReportModalOpen,
    deleteWorkspaceOrReportModalOpen: open,
    rightClickedReportTab: report,
    rightClickedWorkspace: workspace,
    closeWorkspaceTabsMenu,
    closeReportTabsMenu
  } = useWorkspaces();
  const location = useLocation();
  const navigate = useNavigate();

  const isReportDeletion = report && !workspace;

  const modalTitle = `Supprimer ${isReportDeletion ? 'le rapport' : "l'espace"}`;
  const confirmationSentence = isReportDeletion ? 'Êtes-vous sûr de vouloir supprimer définitivement ce rapport ?' : 'Êtes-vous sûr de vouloir supprimer définitivement cet espace ?';

  const onClose = () => {
    closeWorkspaceTabsMenu();
    closeReportTabsMenu();
    setDeleteWorkspaceOrReportModalOpen(false);
  };

  const handleDelete = async () => {
    onClose();
    if (isReportDeletion) {
      const workspaceId = getReportWorkspace(report.report_id).workspace_id;
      const res = await deleteReport(workspaceId, report.report_id);
      const shouldRedirectAfterReportDeletion = res.success && location.pathname.startsWith('/reports');
      if (shouldRedirectAfterReportDeletion) {
        navigate(APP_ROUTES.connections, {state: {workspaceId}});
      }
    } else {
      await deleteWorkspace(workspace.workspace_id);
    }
  };

  return (
    <BaseModal title={modalTitle} maxWidth="sm" onClose={onClose} open={open}>
      <DialogContent sx={{py: 3}}>
        <DialogContentText variant="inherit">{confirmationSentence}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{justifyContent: 'center', mb: 2}}>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Annuler
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete}>
          Supprimer
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

export default DeleteWorkspaceOrReportModal;
